import React from 'react'
import { Header } from '../components'

const SubcategorySpecific = () => {
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header title="Subcategory Specific Keyword Analysis" />
      <p>Subcategory Specific Keyword Analysis</p>
    </div>
  )
}

export default SubcategorySpecific;
